import styled from "styled-components";

const Wrapper = styled.div`
  padding: 12px 0;
  //background-color: pink;
`
const DividerBar = styled.div`
  background-color: ${props => props.theme.dividerColor};
  height: 12px;
`

function Divider() {


  return (
    <Wrapper>
      <DividerBar />
    </Wrapper>
  )
}

export default Divider